import ReactDOM from 'react-dom';
import {ResourceReplacements} from './ResourceReplacements.js'

// Note: this is tightly coupled to existing non-ES6-module JS code on the
// project page. See toggleSections.js in particular.

const isResourceTableExpanded = () => {
	return $('.js-close-breakdown').hasClass('active')
}

const crossOutRows = (replacedResourceIds) => {
	for (let i = 0; i < replacedResourceIds.length; i++) {
		const id = replacedResourceIds[i]
		$(`tr[data-resource-id="${id}"]`).addClass('replaced-resource')
	}
}

const undoCrossOutRows = () => {
	$('.replaced-resource').removeClass('replaced-resource')
}

const toggleReplacementsList = () => {
	$('#replacements-info').toggle()
}

const onExpand = (data) => {
	crossOutRows(data.replacedResourceIds)
	toggleReplacementsList(data)
}

const onContract = (data) => {
	undoCrossOutRows(data.replacedResourceIds)
	toggleReplacementsList(data)
}

const addHandlers = (data) => {
	$('.js-expand-donations-trigger').on('click', function(e) {
		e.preventDefault()
		onExpand(data)
	})
	$('.js-close-breakdown').on('click', function(e) {
		e.preventDefault()
		onContract(data)
	})
}

const handleResponse = (response) => {
	 const data = response

	// For format of data, see replacements.Service.Result.
	if (!data.hasReplacements && !data.hasGiftCode) {
		return
	}

	addHandlers(data)

	ReactDOM.render(
		<ResourceReplacements data={data} />,
		document.getElementById('replacements-info')
	)

	if (isResourceTableExpanded()) {
		onExpand(data)
	}
}

export const main = () => {
	if (!window.mayHaveReplacements) {
		return
	}

	// Delay execution till the first user scroll event comes in.
	// Prevents bots from hitting this AJAX endpoint.
	$(document).on('scroll.resources', () => {
		$(document).off('scroll.resources')

		const projectId = window.proposalId
		const url = `/projects/${projectId}/replacements`
		$.ajax({
			type: 'get',
			url: url,
			dataType: 'json',
		}).done(function(response) {
			handleResponse(response)
		})
	})
}
